<template>
  <div class="row">
    <div class="col-sm-12 col-lg-12">
      <div class="accordion-wrapper">
        <div class="accordion" id="accordionExample">
          <div
            class="card icon-card"
            v-for="(item, index) in info.Sectors"
            :key="index"
          >
            <div class="icon-card__item">
              <div class="icon-card__item__info">
                <img :src="item.Logo" width="45" />
                <h2>
                  {{ item.Name }}
                </h2>
              </div>
              <div class="icon-card__item__readmore">
                <a :href="item.LinkToDetails"
                  ><span>{{ ReadMore }} </span>
                  <img
                    src="../../../Assets/Images/Sectorlist/circle-arrow.svg"
                    width="25"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
let baseUrl = document.location.origin;
let apiUrl = baseUrl + "";
let language = window.CurrentLanguage.CurrentLanguage;
export default {
  data() {
    return {
      info: [],
    };
  },
  props: ["ReadMore"],
  methods: {
    getFilterData() {
      this.isAjaxLoading = true;
      this.noDataMsg = false;
      axios
        .post(`${apiUrl}/Umbraco/Surface/Generic/GetAllSectors?culture=${language}`)
        .then((response) => {
          this.info = response.data;
        });
    },
  },
  mounted() {
    this.getFilterData();
    document.querySelector(".register-page-form__loader").style.display =
      "none";
  },
};
</script>
